import React, { useState } from 'react';
import { X, Camera, Fish } from 'lucide-react';
import { useApp } from '../../context/AppContext';
import { motion, AnimatePresence } from 'framer-motion';
interface CatchLogModalProps {
  isOpen: boolean;
  onClose: () => void;
  locationId: string;
  locationName: string;
}
export function CatchLogModal({
  isOpen,
  onClose,
  locationId,
  locationName
}: CatchLogModalProps) {
  const {
    addCatch
  } = useApp();
  const [species, setSpecies] = useState('Trout');
  const [weight, setWeight] = useState('');
  const [length, setLength] = useState('');
  const [notes, setNotes] = useState('');
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    addCatch({
      id: Date.now().toString(),
      species,
      weight: Number(weight),
      length: Number(length),
      locationId,
      date: new Date().toISOString(),
      notes
    });
    onClose();
    setWeight('');
    setLength('');
    setNotes('');
  };
  return <AnimatePresence data-id="element-14">
      {isOpen && <div className="fixed inset-0 z-50 flex items-center justify-center p-4" data-id="element-15">
          <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} className="absolute inset-0 bg-black/40 backdrop-blur-sm" onClick={onClose} data-id="element-16" />

          <motion.div initial={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} exit={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} transition={{
        type: 'spring',
        stiffness: 400,
        damping: 30
      }} className="relative w-full max-w-md float-card overflow-hidden" data-id="element-17">
            {/* Header */}
            <div className="flex items-center justify-between p-4 border-b border-[var(--border-subtle)]" data-id="element-18">
              <div data-id="element-19">
                <h2 className="text-lg font-semibold text-[var(--text-primary)]" data-id="element-20">
                  Log catch
                </h2>
                <p className="text-sm text-[var(--text-muted)]" data-id="element-21">
                  {locationName}
                </p>
              </div>
              <button onClick={onClose} className="p-2 rounded-xl hover:bg-[var(--bg-secondary)] transition-colors" data-id="element-22">
                <X className="w-5 h-5 text-[var(--text-muted)]" data-id="element-23" />
              </button>
            </div>

            <form onSubmit={handleSubmit} className="p-4 space-y-4" data-id="element-24">
              {/* Species */}
              <div data-id="element-25">
                <label className="text-xs font-medium text-[var(--text-muted)] uppercase tracking-wide mb-1.5 block" data-id="element-26">
                  Species
                </label>
                <select value={species} onChange={e => setSpecies(e.target.value)} className="w-full p-3 rounded-xl input-minimal text-[var(--text-primary)]" data-id="element-27">
                  <option data-id="element-28">Trout</option>
                  <option data-id="element-29">Bass</option>
                  <option data-id="element-30">Salmon</option>
                  <option data-id="element-31">Pike</option>
                  <option data-id="element-32">Halibut</option>
                </select>
              </div>

              {/* Weight & Length */}
              <div className="grid grid-cols-2 gap-3" data-id="element-33">
                <div data-id="element-34">
                  <label className="text-xs font-medium text-[var(--text-muted)] uppercase tracking-wide mb-1.5 block" data-id="element-35">
                    Weight (lbs)
                  </label>
                  <input type="number" step="0.1" value={weight} onChange={e => setWeight(e.target.value)} className="w-full p-3 rounded-xl input-minimal text-[var(--text-primary)]" placeholder="0.0" required data-id="element-36" />
                </div>
                <div data-id="element-37">
                  <label className="text-xs font-medium text-[var(--text-muted)] uppercase tracking-wide mb-1.5 block" data-id="element-38">
                    Length (in)
                  </label>
                  <input type="number" step="0.1" value={length} onChange={e => setLength(e.target.value)} className="w-full p-3 rounded-xl input-minimal text-[var(--text-primary)]" placeholder="0.0" required data-id="element-39" />
                </div>
              </div>

              {/* Notes */}
              <div data-id="element-40">
                <label className="text-xs font-medium text-[var(--text-muted)] uppercase tracking-wide mb-1.5 block" data-id="element-41">
                  Notes
                </label>
                <textarea value={notes} onChange={e => setNotes(e.target.value)} className="w-full p-3 rounded-xl input-minimal text-[var(--text-primary)] h-20 resize-none" placeholder="Lure, conditions..." data-id="element-42" />
              </div>

              {/* Photo */}
              <button type="button" className="w-full p-4 rounded-xl border-2 border-dashed border-[var(--border)] hover:border-[var(--accent)] hover:bg-[var(--accent-light)] transition-colors flex flex-col items-center text-[var(--text-muted)]" data-id="element-43">
                <Camera className="w-6 h-6 mb-1" data-id="element-44" />
                <span className="text-sm" data-id="element-45">Add photo</span>
              </button>

              {/* Submit */}
              <button type="submit" className="w-full btn-accent py-3.5 flex items-center justify-center space-x-2" data-id="element-46">
                <Fish className="w-5 h-5" data-id="element-47" />
                <span data-id="element-48">Save catch</span>
              </button>
            </form>
          </motion.div>
        </div>}
    </AnimatePresence>;
}